<template>
  <div class="section-nav">
    <ul class="container">
      <li v-for="section in getSections()"
          :key="section.id">
        <span :title="section.title"
              class="section-nav-item"
              @click="scrollTo(section.id)">{{ $t(section.text) }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    sections: {
      type: Array,
      default: () => []
    },
    haveDescription: {
      type: Boolean,
      default: false
    },
    haveGallery: {
      type: Boolean,
      default: false
    },
    haveEvents: {
      type: Boolean,
      default: false
    },
    haveArtists: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getSections() {
      let sections = []
      this.sections.forEach(item => {
        if (
          (item.id === 'events' && this.haveEvents) ||
          (item.id === 'info' && this.haveDescription) ||
          (item.id === 'gallery' && this.haveGallery) ||
          (item.id === 'artists' && this.haveArtists)
        ) {
          sections.push(item)
        } else if (
          item.id !== 'events' &&
          item.id !== 'info' &&
          item.id !== 'gallery' &&
          item.id !== 'artists'
        ) {
          sections.push(item)
        }
      })
      return sections
    },
    scrollTo(id) {
      var element = document.getElementById(id)
      var options = {
        offset: -150
      }
      this.$scrollTo(element, 500, options)
    }
  }
}
</script>
<style lang="scss">
@import './section-nav.sass';
</style>
